/**
 * Recursively removes __typename from objects and nested structures
 * Used to clean Apollo Client cached data before sending mutations
 * @param obj Any object or primitive value
 * @returns The same object without __typename fields
 */
export function removeTypename<T>(obj: T): T {
  if (!obj || typeof obj !== 'object') return obj

  if (Array.isArray(obj)) {
    return obj.map(removeTypename) as T
  }

  const { __typename, ...rest } = obj as Record<string, unknown>

  return Object.keys(rest).reduce<Record<string, unknown>>((acc, key) => {
    acc[key] = removeTypename(rest[key])
    return acc
  }, {}) as T
}
